import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import BookingCard from "../../../../../../../../components/ui/Booking/BookingCard";
import { Loading } from "../../../../../../../../components/ui/Loading";
import { useAuthenticatedApi } from "../../../../../../../../hooks/useApi";
import { trackZostelEvent } from "../../../../../../../../utils/tracking";

interface UserUpcomingBookingProps {}

const UpcomingBooking: React.FC<UserUpcomingBookingProps> = () => {
  const [booking, setBooking] = useState([]);
  const [loading, setLoading] = useState(true);
  const api = useAuthenticatedApi("STAY_MY_BOOKINGS");
  const history = useHistory();
  useEffect(() => {
    if (api) {
      api.get("?type=upcoming").then((res: any) => {
        setBooking(res.data.bookings);
        setLoading(false);
      });
    }
  }, [api]);

  const goToBooking = (data: any) => {
    gtag("event", "View_Booking", { value: data.code ? data.code : null });
    trackZostelEvent("View_Booking", {
      value: data.code ? data.code : null,
    });
    history.push(`/booking-info/${data.code}/`);
  };
  return (
    <>
      {loading ? (
        <div className="flex flex-col items-center">
          <Loading className="w-12" />
          <span className="mt-4 text-lg font-medium">Please Wait</span>
          <span className="mt-2 text-sm font-medium text-subtitle">
            Fetching Booking information
          </span>
        </div>
      ) : booking && booking.length > 0 ? (
        <>
          <h2 className="px-4 text-2xl font-medium sm:text-xl">
            Upcoming <span className="text-orange">Booking</span>
          </h2>
          {booking.map((bookingData, index) => (
            <BookingCard
              key={index}
              bookingData={bookingData}
              onPress={goToBooking}
            />
          ))}
        </>
      ) : (
        <div className="flex flex-col items-center py-12">
          <span className="mt-4 text-lg font-medium">
            There is no upcoming booking available
          </span>
          <span className="mt-2 text-sm font-medium text-subtitle">
            Please book from our various
            <a
              href="https://www.zostel.com/zostel/"
              className="ml-1 underline text-orange"
            >
              destinations
            </a>
          </span>
        </div>
      )}
    </>
  );
};

export default UpcomingBooking;
